import { z } from 'zod';

// ---------- REST response DTOs (runtime-validated) ----------

/** Role resolved by the backend. Static dev tokens and OIDC (`shift_supervisor` claim) both map onto these two. */
export const ROLES = ['viewer', 'supervisor'] as const;
export const Role = z.enum(ROLES);
export type Role = z.infer<typeof Role>;

/** How the backend verifies bearer tokens (`AUTH_MODE`). */
export const AUTH_MODES = ['static', 'oidc'] as const;
export const AuthMode = z.enum(AUTH_MODES);
export type AuthMode = z.infer<typeof AuthMode>;

/** Body of `GET /api/me`: the caller as the server sees it. */
export const MeResponse = z.object({ user: z.string().min(1), role: Role }).strict();
export type MeResponse = z.infer<typeof MeResponse>;

/**
 * Body of `GET /api/health` (no auth). `time` is the server ISO timestamp, `shops` the shop ids with a live hub.
 * `demoControls` is true when the backend serves the supervisor-only `/api/demo/faults/*` drills (`DEMO_CONTROLS=true`).
 */
export const HealthResponse = z
  .object({
    status: z.literal('ok'),
    time: z.string().datetime(),
    shops: z.array(z.string()),
    authMode: AuthMode,
    demoControls: z.boolean(),
  })
  .strict();
export type HealthResponse = z.infer<typeof HealthResponse>;
